const translations = {
    address: 'Address',
    address2: '(Optional)',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
